

import React, { useState } from "react";
import Modal from "react-modal";
import { InnerBanner } from "container/InnerpageBanner/index2";
import { ArrowButton } from "molecules/ArrowButton";
import { BigImgBox } from "molecules/BigImgBox";
import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { SectionBorder } from "molecules/SectionBorder";
import { TitleHeading } from "molecules/TitleHeading";
import { TestimonialSection } from "./testimonial";
import { Carousel } from "primereact/carousel";
import { responsiveSliderOptions } from "../../assets/config";
import { SmallHadding } from "molecules/SmallHeadding";
import { Paginator } from "primereact/paginator";
import styled from "styled-components";
import { MainSlider } from "component/MainSlider";
import CommonCarousel from "component/commonCarousel/commonCarousel";
// import { Carousel } from "primereact/carousel";

const CustPaginator = styled(Paginator)`
  .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
    color: #000;
  }

  .p-paginator-pages {
    margin: 0 1rem;
  }
  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    border-color: #010101;
    color: #fff;
    cursor: default;
  }

  .p-paginator-pages .p-paginator-page {
    border: none;
    border-radius: 50% !important;
    color: #010101;
    float: left;
    font-size: 18px;
    font-weight: 500;
    height: 2pc;
    line-height: 2pc;
    min-width: 2pc;
    padding: 0 !important;
    text-align: center;
    text-decoration: none;
  }

  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
    text-decoration: none;
  }
`;

export const CommunityImpect = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [sliderdata2, setSliderdata2] = useState([
    {
      name: "Amit Tindwani",
      desig: "Chief Sustainability Officer",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but a...",
      image: "media/testimonail-user-img.png",
    }
  ]);



  const [sliderdata1, setSliderdata1] = useState([
    {
      name: "Amit Tindwani",
      desig: "Chief Sustainability Officer",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but a...",
      image: "media/testimonail-user-img.png",
    },
    {
      name: "Amit Tindwani",
      desig: "Chief Sustainability Officer",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but a...",
      image: "media/testimonail-user-img.png",
    },
    {
      name: "Amit Tindwani",
      desig: "Chief Sustainability Officer",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but a...",
      image: "media/testimonail-user-img.png",
    },
    {
      name: "Amit Tindwani",
      desig: "Chief Sustainability Officer",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but a...",
      image: "media/testimonail-user-img.png",
    },
  ]);


  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const manage_data = [
    {
      icon: "/media/diversity-icon.png",
      label: "Diversity",
      details: "Quantum is driven by its Vision statement: To elevate the professional standards of the Indian realty sector...",
    },
    {
      icon: "/media/equity-icon.png",
      label: "Equity",
      details: "Quantum is driven by its Vision statement: To elevate the professional standards of the Indian realty sector...",
    },
    {
      icon: "/media/inclusion-icon.png",
      label: "Inclusion",
      details: "Quantum is driven by its Vision statement: To elevate the professional standards of the Indian realty sector...",
    },
  ];

  const sliderdata = [
    {
      title: "Lorem Ipsum is simply dummy te",
      description: "Quantum is driven by its Vision statement: To elevate the professional standards...",
      image: "media/home_slider/blog-1-400x248 1.png",
    },
    {
      title: "Lorem Ipsum is simply dummy te",
      description: "Quantum is driven by its Vision statement: To elevate the professional standards...",
      image: "media/home_slider/blog-1-400x248 1 (1).png",
    },
    {
      title: "Lorem Ipsum is simply dummy te",
      description: "Quantum is driven by its Vision statement: To elevate the professional standards...",
      image: "media/home_slider/blog-1-400x248 1.png",
    },
    {
      title: "Lorem Ipsum is simply dummy te",
      description: "Quantum is driven by its Vision statement: To elevate the professional standards...",
      image: "media/home_slider/blog-1-400x248 1 (2).png",
    },
  ];



  const productTemplate1 = (item) => {
    return (
      <div className=" px-3 p-6 grid " style={{ backgroundColor: 'transparent', overflow: 'visible' }}>
        <div className="lg:col-4 md:col-5 sm:col-12 pb-0"  >
          {/* <div className="testimonial-user-box" > */}
          <img src={`${item.image}`} alt={item.name} style={{ position: 'absolute', height: '120%' }} />
          {/* </div> */}
        </div>
        <div className="lg:col-8 md:col-7 sm:col-12" style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
          <div className="grid">
            <div className="lg:col-9 md:col-9 sm:col-12 md:col-offset-2">
              <h6 className="text-white fs-27 font-normal mb-5 mt-2">
                {item.description}
              </h6>
              <h4 className="mb-0 fs-21 font-normal thm-yellow">{item.name}</h4>
              <h5 className="my-3 fs-17 font-normal" style={{ color: '#fff' }}>{item.desig}</h5>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'80%',
      zIndex:2000,
   
    },
  };
  const backgroundColors = ['#EAEBEB', '#DFE0E1', '#D1D2D4'];

  const openModal = (index) => {
    if (sliderdata && sliderdata.length > 0) {
      console.log("Slider Data:", sliderdata);
      console.log("Current Slide Index:", index);
      setCurrentSlide(index);
      setModalIsOpen(true);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const productTemplate = (item, index) => {
    return (
      <div className="text-justify p-3 insightDiv " onClick={() => openModal(index)}>
        <div className="image-container" data-aos="fade-up">
          <img
            src={item.image}
            className="w-full zoom-image "
            alt={item.title}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          />
        </div>
        <h2 className="underlineText"
          style={{ textAlign: 'left' }}
        // className={hoveredIndex === index ? 'underline' : ''}
        >
          {item.title}
        </h2>
        <DetailBox details={item.description} className="two-line-text" />
      </div>
    );
  };

  // const productTemplate2 = (item) => {
  //   return (
  //     <div className=" px-3 p-6 grid " style={{backgroundColor:'transparent',overflow:'visible'}}>
  //       <div className="lg:col-4 md:col-5 sm:col-12 pb-0"  >
  //         <div className="testimonial-user-box" >
  //           <img src={`${item.image}`} alt={item.name}  className="img-fluid"  style={{position:'absolute',zIndex:"10000"}} />
  //         </div>
  //       </div>
  //       <div className="lg:col-8 md:col-7 sm:col-12" style={{display:"flex",alignItems:'center',justifyContent:'center'}}>
  //         <div className="grid">
  //           <div className="lg:col-9 md:col-9 sm:col-12 md:col-offset-2">
  //             <h6 className="text-white fs-27 font-normal mb-5 mt-2">
  //               {item.description}
  //             </h6>
  //             <h4 className="mb-0 fs-21 font-normal thm-yellow">{item.name}</h4>
  //             <h5 className="my-3 fs-17 font-normal" style={{color:'#fff'}}>{item.desig}</h5>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const [first, setFirst] = useState(0);
  // const [rows, setRows] = useState(3); // Number of visible items
  const [activePage, setActivePage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const rows = 3; // Assuming 3 items per page for pagination
  // const sliderdata = [...] 

  const onPageChange = (event) => {
    setActiveIndex(event.first);
  };

  const handleSlideClick = (slide) => {
    console.log("Slide clicked:", slide);
  };

  return (
    <div className="backgroundThm mobileContainer"
    >
      <div className="container  px-0  ">

        <Crumbs />
       
        <div className="container px-0  ">             
        <InnerBanner
          bannertext="Lorem Ipsum is simply dummy text of the printing and typesetting..."
          innertitle="Community Impact"
        />
        </div>
        </div>
      
      <div className="container  py-0 px-0 ">
      <section className="section-padding  px-0">
        <div className="container  px-0  ">
        <div className="container pr-0 pl-0   ">
          <div className="spaceBetweenFlexRow " style={{ }}>
            <div className="" style={{  }}>
              <TitleHeading title="Alternative assets, end-to-end managed" className="mt-0 p-0" />
            </div>
           
            <div className=" -mr-1  pr-0 EndFlexRow " style={{  }}>

              {manage_data.map((item, index) => (
                <div key={index} className=" communityImpactContainer " style={{  backgroundColor: backgroundColors[index % backgroundColors.length] }} >

                  <h4 className="  uppercase text-left font19" style={{ fontFamily: 'Avenir',fontWeight:"550",color:"rgb(66,66,66)",fontSize:"19px !important" }}>
                  {item.label}
                  </h4>
                 
                
                  <DetailBox details={item.details} className="" style={{ marginBottom: '-10px' }} />
              
                </div>
              ))}
            </div>
            
          
          </div>
         
          
       </div>
       <div className="container borderSpacing pl-0  pr-1">
          <SectionBorder />
          </div>
     
          
        </div>
      
      </section>
      </div>


      <div className="container px-0 ">
      
      <section className="section-padding1 px-0 pb-0 pt-0" style={{}}>
        <div className="container    -mb-5 pl-0 pr-0">
        <div className="container pl-0 pr-0"style={{marginTop:'-10px'}}>
          <div className=" section-title spaceBetweenFlexRow" style={{ alignItems: 'flex-start' }}>
            <div className="lg:col-3 md:col-3 sm:col-12 p-0" >
              <TitleHeading title="Our Purpose & Values" className="mt-0 mb-3" />
            </div>
            <div className="lg:col-5 md:col-5 sm:col-12">
              <DetailBox
                details="Quantum is driven by its Vision statement: To elevate the professional standards Quantum is driven by its Vision statement: To elevate the professional standards..."
                className=" text-justify mt-0 mb-3"
              />
            </div>
            <div className="lg:col-3 md:col-4 sm:col-12 pr-1 mt-1">
              <div className="flex justify-content-end">
                <ArrowButton
                  width="170"
                  buttonText="Learn more"
                  bgColor="#CDC08B"
                  textColor="#000000"
                  url="/"
                  className="ml-0"
                />
              </div>
            </div>
          </div>
          {/* <div className="" style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
            <div className="pr-1 communityImage" style={{ }}>
             
             
              <img src="/media/Rectangle 33.png" className="img-fluid"/>
            </div>
          </div> */}




<div className="" style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
  <div className="pr-1 communityImage" style={{ position: 'relative', height: '0', paddingBottom: '50.25%' }}>
    <img 
      src="/media/Rectangle 33.png" 
      className="img-fluid" 
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '70%', objectFit: 'cover' }} 
    />
  </div>
</div>

        </div>
        </div>
      </section>

      </div>

      
        <div className="containe ">
      
      <section className="section-padding pt-0 thmbg-nvblue text-white p-0 heigh400   SustainabilitySection relative" style={{ backgroundColor: '#424242',   }}>
      <div className="container">
        <div className="card" style={{ backgroundColor: 'transparent', border: 0,  }}>
          {sliderdata2?.map((item, i) => {
            return (<div className=" px-3 p-6 grid " style={{ backgroundColor: 'transparent', overflow: 'visible' }}>
              <div className="lg:col-4 md:col-5 sm:col-12 pb-0"  >
                <div className="testimonial-user-box " >
                  <img className="communityMainBannerImage" src={`${item.image}`} alt={item.name}  />
                </div>
              </div>
              <div className="lg:col-8 md:col-7 sm:col-12 pt-0" style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                <div className="grid">
                  <div className="lg:col-9 md:col-9 sm:col-12 md:col-offset-2 ">
                    <h6 className="text-white font23 font-normal mt-2">
                      {item.description}
                    </h6>
                    <h4 className="mb-0 fs-21 my-3 font-normal thm-yellow">{item.name}</h4>
                    <h5 className="my-3 fs-17 font-normal" style={{ color: '#fff' }}>{item.desig}</h5>
                  </div>
                </div>
                </div>
            
            </div>)
          })}
     
        </div>
       
      </div>  
      </section>
      </div>

      <div className="container px-0 ">
      <section className="section-padding1 px-0 pb-2">
        <div className="container   pr-0 pl-1" style={{overflow:'hidden'}}>
          <div className="grid section-title justify-content-between  align-items-center">
            <div className="lg:col-6 md:col-6 sm:col-12 p-0   mb-2">
              <TitleHeading title="Our Social Impact" className="mt-0 mb-0" />
            </div>
            <div className="lg:col-6 md:col-6 sm:col-12  pr-0 mt-1">
              <div className="flex  justify-content-end">
                <ArrowButton
                  width="170"
                  buttonText="View All"
                  bgColor="#CDC08B"
                  textColor="#000000"
                  url="/"
                  className="ml-0"
                />
              </div>
            </div>
          </div>
       
       <div className=" " style={{}}>
       {/* <MainSlider data={sliderdata} titlecss="text-center"  onSlideClick={openModal}  /> */}

       {window.innerWidth > 768 ? (
             <MainSlider data={sliderdata} titlecss="text-center" onSlideClick={openModal} />
            ):(
              
            <CommonCarousel data={sliderdata} rows={1} slidesToShow={1} onSlideClick={openModal} />
          )}
       </div>

        </div>
      </section>
      </div>

      {/* Popup Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Project Detail Modal"
        // style={{backgroundColor:'red'}}
        
      >
        {/* <div style={{width:'80%'}}> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #C82027",
            marginBottom: "20px",
            width: "100%",
 
          }}
        >
          <p style={{ fontWeight: "500", fontSize: "20px" }}>
            {sliderdata[currentSlide].title}
          </p>
          <button
            onClick={closeModal}
            style={{ float: "right" }}
            className="btn bg-tranper border-none shadow-none p-1 cursor-pointer text-center"
          >
            <i className={`pi pi-times float-ri thm-red fs-25`}></i>
          </button>
        </div>

        <div className="containerNew d-flex align-items-lg-start ">
          <div className="column1 p-0 pt-3">
          <p className="font17" style={{ width: '50%', marginBottom: '-1%',fontWeight:600 }}>Location:</p>
            <p className="font17">Hyderabad</p>
            <p className="font17">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quisquam
              quaerat eius non. Omnis, neque officia voluptatibus ipsam
              blanditiis ratione quibusdam non molestiae adipisci, cum modi et
              dolorem facilis consequuntur reiciendis.
            </p>
          </div>
          <div className="column1 image-container" style={{}}>




            <img
              src={sliderdata[0].image}
              alt="Popup Slider"
              className="w-100"
            />

            <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center', paddingTop: '2%' }}>
              <button
                style={{
                  position: "relative",
                  // top: "50%",
                  // left: "-10px",
                  // transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setCurrentSlide(
                    currentSlide === 0 ? sliderdata.length - 1 : currentSlide - 1
                  )
                }
              >
                <i className="pi pi-arrow-circle-left" style={{ fontSize: "2rem" }}></i>
              </button>


              <button
                style={{
                  position: "relative",
                  // top: "50%",
                  // right: "-10px",
                  // transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setCurrentSlide(
                    currentSlide === sliderdata.length - 1 ? 0 : currentSlide + 1
                  )
                }
              >
                <i className="pi pi-arrow-circle-right" style={{ fontSize: "2rem" }}></i>
              </button>
            </div>
          </div>
        </div>
        {/* </div> */}
      </Modal>
    </div>
  );
};

